import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from '../../util/reactIntl';
import { Heading, ExternalLink } from '../../components';

import css from './ProfilePage.module.css';
import { getPlatform } from '../../components/CustomExtendedDataField/CustomExtendedDataField';

const SectionWebsiteMaybe = ({
  websiteFields = [],
}) => {
  if (!websiteFields || websiteFields.length === 0) {
    return null;
  }

  return (
    <div className={css.sectionWebsite}>
      <Heading as="h2" rootClassName={css.sectionHeading}>
        <FormattedMessage id="ProfilePage.reachMeAtTitle" />
      </Heading>
      <ul className={css.websiteLinks}>
        {websiteFields.filter(field => !getPlatform(field.key)).map((field, index) => (
          <li key={index} className={css.websiteLink}>
            <ExternalLink href={field.text} className={css.websiteUrl}>
              {new URL(field.text).hostname.replace('www.', '')}
            </ExternalLink>
          </li>
        ))}
      </ul>
    </div>
  );
};

SectionWebsiteMaybe.propTypes = {
  websiteFields: PropTypes.arrayOf(
    PropTypes.shape({
      text: PropTypes.string.isRequired,
    })
  ),
};

export default SectionWebsiteMaybe;
